<template>
  <div class="">
    <Card back>
      <template v-slot:header>
        <h5>لیست درخواست های {{ FormName }}</h5>
      </template>
      <template v-slot:content>
        <div class="">
          <bnp-grid :key="Render" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true">
            <template slot="action-slot" slot-scope="props">
              <request-info :RequestRow="props.props" :ApiAction="ApiAction" @Success="RefreshGrid" @DataEdit="DataEdit" :IsSarparast="true"></request-info>
              <div class="d-inline" v-if="props.props.hasReject">
                <i class="fad fa-share mt-2 hover-warning Pointer" title="مرجوع کردن" @click="Reject(props.props)"></i>
              </div>
            </template>

            <template slot="Description" slot-scope="props">
              <textarea class="form-control" v-model="Rows[props.indexRow - 1].Description" placeholder="توضیحات مسئول"></textarea>
            </template>
            <template slot="filePath" slot-scope="props">
              <a download="props.props.id" target="new" v-if="props.props.filePath != null && tblformAutomationId == 1" :href="$cookies.get('URL') + props.props.filePath"> <i class="fad fa-download"></i></a>
              <a download="props.props.id" target="new" v-if="props.props.filepath != null && tblformAutomationId != 1" :href="$cookies.get('URL') + props.props.filepath"> <i class="fad fa-download"></i></a>
            </template>
            <template slot="tblcombogrpId101VaziatName" slot-scope="props">
              <div class="d-inline" v-if="props.props.hasAccept">
                <SearchableCombo :edit="false" :grp="101" @ResultCombo="GetResulGrp101" :defaultvalue="props.props.tblcomboGrp101Vaziat" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="props.props.id" :keyItem="'Combo' + props.props.id" :ClassProps="'required text-center d-inline'">
                </SearchableCombo>
              </div>
              <div class="d-inline" v-if="props.props.hasDo">
                <select class="form-control text-center d-inline" @change="ChangeHasDo($event, props.props)">
                  <option :value="-1">انتخاب وضعیت</option>
                  <option :value="1085234">انجام شد</option>
                  <option :value="1085232">انجام نشد</option>
                </select>
              </div>
            </template>
            <!-- <template slot="authPrevPerson" slot-scope="props">
              <span >{{ props.props.authPrevPerson==0?'سرپرستی وجود ندارد':props.props.authPrevPerson==1085233?'درحال بررسی':props.props.authPrevPerson==1085232?'رد شد':props.props.authPrevPerson==1085234?'تایید شد': 'نامشخص'}}</span>
            </template> -->

            <template slot="tblCombogrp102NoeDarkhast" slot-scope="props">
              <span v-if="props.props.tblCombogrp102NoeDarkhast == 1085236">ساعتی </span>
              <span v-if="props.props.tblCombogrp102NoeDarkhast == 1085235">روزانه </span>
            </template>
            <template slot="tblcombogrp103NoeMorakhasi" slot-scope="props">
              <span v-if="props.props.tblcombogrp103NoeMorakhasi == 1085237">استحقاقی </span>
              <span v-if="props.props.tblcombogrp103NoeMorakhasi == 1085238">استعلاجی </span>
              <span v-if="props.props.tblcombogrp103NoeMorakhasi == 1085239">بدون حقوق </span>
            </template>
            <template slot="startTime" slot-scope="props">
              <span v-if="props.props.startTime == 'null' && tblformAutomationId == 1"> --</span>
              <span v-if="props.props.startTime != 'null' && tblformAutomationId == 1"> {{props.props.startTime}}</span>
              <span v-if="tblformAutomationId != 1"> {{ props.props.startTime === 'null '?'--':props.props.startTime }}</span>
            </template>
            <template slot="endTime" slot-scope="props">
              <span v-if="props.props.endTime == 'null' && tblformAutomationId == 1"> --</span>
              <span v-if="props.props.endTime != 'null' && tblformAutomationId == 1"> {{props.props.endTime}}</span>
             <span v-if="tblformAutomationId != 1"> {{ props.props.endTime === 'null '?'--':props.props.endTime }}</span>
            </template>
            <template slot="calcDateTime" slot-scope="props">
              <span v-if="props.props.tblCombogrp102NoeDarkhast == 1085235">{{ props.props.countDate }} روز</span>
            </template>
            <template slot="tarixTa" slot-scope="props">
              <span v-if="props.props.tarixTa == 'null'"></span>
              <span v-else>{{ props.props.tarixTa }}</span>
            </template>
            <template slot="amount" slot-scope="props">
              <span>{{ $Comma3ragham(props.props.amount) }}</span>
            </template>
          </bnp-grid>
        </div>
      </template>
    </Card>
    <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Sm'">
      <template v-slot:body>
        <div class="row px-5" id="RejectForm" v-if="ListSteepWorkflow.length">
          <div class="col-12 text-center mb-3 text-warning">انتخاب مرحلـــه ارجاع نامه</div>
          <div class="col-12">
            <small>توضیحات مربوط به ارجاع</small>
            <input class="form-control required" type="text" v-model="RejectDescription" />
            <hr />
          </div>
          <div class="col-md-6 col-12" v-for="(item, key) in ListSteepWorkflow" :key="key">
            <div class="box p-2 Pointer" @click="ChangeActiveSteep(item)">
              {{ item.levelName }}
            </div>
          </div>
        </div>
        <div class="row px-5" v-else>
          <div class="col-12 alert alert-warning text-dark">در این مرحله امکان ارجاع وجود ندارد</div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import RequestInfo from '@/components/AutomAtion/RequestInfo.vue'
import Modal from '../Modal/Modal.vue'

export default {
  data() {
    return {
      Render: 0,
      Rows: [],
      Column: [],
      FormName: '',
      ApiAction: '',
      ListSteepWorkflow: [],
      RowRejected: {},
      RejectDescription: '',
    }
  },
  props: ['tblformAutomationId'],
  methods: {
    GetData() {
      this.Rows = []
      var AxiosGet = { ArryfildValue: {}, Method: 'post', Action: 'ListProcessWorkFlow/FindFormFromList', Token: this.$session.get('Token') }
      AxiosGet.ArryfildValue = this.tblformAutomationId
      this.$PostData(AxiosGet).then((res) => {
        if (res.status == 'Success') {
          var result = {}
          res.data.forEach((el) => {
            for (var id in el.selProcessWorkFlowForUser) {
              el.tblLeaveRequests[id] = el.selProcessWorkFlowForUser[id]
            }
            el.tblLeaveRequests['Description'] = ''
            this.Rows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
            // console.log('😎 ~ res.data.forEach ~ this.Rows:', this.Rows)
            this.Render++
          })
          // console.log('😎 ~ this.$PostData ~ res.data:', this.Rows)
        }
      })
    },
    GetResulGrp101(val) {
      if (val.id && val.id != 1085233 && val.id != 2727) {
        let Vaziat = val.id == 1085232 ? 'رد شد ' : val.id == 1085234 ? 'تایید شد' : 'نامعلوم'
        this.$SweetQustion('تغییر وضعیت', 'از تغییر وضعیت درخواست به ' + Vaziat + ' اطمینان دارید ؟ ', 'warning', 'تایید', ' انصراف ', val, this.Accept, this.Cancel)
      }
    },
    Accept(val) {
      const IdRow = Number(val.key.split('Combo')[1])
      // console.log("😎 ~ Accept ~ val:", this.Rows.find((x) => x.id == IdRow))
      let Vaziat = val.id == 1085232 ? 'رد شد ' : val.id == 1085234 ? 'تایید شد' : 'نامعلوم'
      var SendData = { Action: 'ListProcessWorkFlow/ChangeComboGrp101VAaziat', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('id', IdRow)
      formData.append('tblComboGrpId101Vaziat', val.id)
      formData.append('fkId', this.Rows.find((x) => x.id == IdRow).fkId)
      formData.append('Description', this.Rows.find((x) => x.id == IdRow).Description)
      formData.append('Condition', this.Rows.find((x) => x.id == IdRow).condition)
      formData.append('tartib', this.Rows.find((x) => x.id == IdRow).tartib)
      formData.append('tblDepartmentId', this.Rows.find((x) => x.id == IdRow).tblDepartementId)
      formData.append('tblformAutomationId', this.Rows.find((x) => x.id == IdRow).tblFormAutomationId)
      SendData.ArryfildValue = formData
      console.log(this.Rows.find((x) => x.id == IdRow).condition);
      console.log(val);
      this.$PostFormData(SendData).then((result) => {
        //console.log('😎 ~ this.$PostFormData ~ result:', result)
        if (result.status == 'Ok') {
          this.$toasted.success('تغییر وضعیت به حالت ' + Vaziat + ' با موفقیت انجام شد ')
          this.GetData()
          this.Render++
        }
      })
    },
    ChangeHasDo(val, row) {
      var find = this.Rows.find((x) => x.id == row.id)
      find.tblcomboGrp101Vaziat = Number(val.target.value)
      if (val != -1) {
        let Vaziat = val.target.value == 1085232 ? 'انجام نشد ' : val.target.value == 1085234 ? 'انجام شد' : 'نامعلوم'
        this.$SweetQustion('تغییر وضعیت', 'از تغییر وضعیت درخواست به ' + Vaziat + ' اطمینان دارید ؟ ', 'warning', 'تایید', ' انصراف ', find, this.AcceptChangeHasDo, this.Cancel)
      }
    },
    AcceptChangeHasDo(val) {
      var SendData = { Action: 'ListProcessWorkFlow/ChangeComboGrp101VAaziat', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('id', val.id)
      formData.append('tblComboGrpId101Vaziat', val.tblcomboGrp101Vaziat)
      formData.append('fkId', val.fkId)
      formData.append('Description', val.Description)
      formData.append('Condition', val.condition)
      formData.append('tartib', val.tartib)
      formData.append('tblDepartmentId', val.tblDepartementId)
      formData.append('tblformAutomationId', val.tblFormAutomationId)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        //console.log('😎 ~ this.$PostFormData ~ result:', result)
        if (result.status == 'Ok') {
          this.$toasted.success('تغییر وضعیت به حالت ' + Vaziat + ' با موفقیت انجام شد ')
          this.GetData();
          this.Render++
        }
      })
    },
    DataEdit() {},
    RefreshGrid() {},
    Reject(row) {
      this.RowRejected = row
      this.ListSteepWorkflow = []
      var SendData = { Action: 'ListProcessWorkFlow/Reject', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('fkid', row.fkId)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.status == 'Success') {
         
          for (let i = 0; i < row.tartib; i++) {
            var f = result.data.find((x) => x.tartib == i && x.tartib != row.tartib)
            if (f) {
              this.ListSteepWorkflow.push(f)
            }
          }
          if (this.ListSteepWorkflow.length > 0) {
            this.$store.state.Modal = true
          } else {
            this.$toasted.error('در این مرحله امکان ارجاع نامه وجود ندارد ', { duration: 2500 })
          }
        }
      })
    },
    ChangeActiveSteep(row) {
      if (this.$ValidForm('RejectForm')) {
        var formData = new FormData()
        formData.append('tblProcessWorkflowId', this.RowRejected.id)
        formData.append('fkid', this.RowRejected.fkId)
        formData.append('tartib', row.tartib)
        formData.append('tblAutomationId', row.tblFormAutomationId)
        formData.append('tblDepartemantId', row.tblDepartementId)
        formData.append('RejectDescription', this.RejectDescription)
        var SendData = { Action: 'ListProcessWorkFlow/ChangeActiveSteep', Method: 'POST', ArryfildValue: formData, Token: this.$session.get('Token') }
        this.$PostFormData(SendData).then((res) => {
          if (res.status == 'Success') {
            this.$toasted.success('ارجاع نامه با موفقیت انجام گردید', { duration: 2000 })
            this.GetData()
            this.Render++
          }
        })
      }
    },
  },
  created() {
    if (this.tblformAutomationId) {
      this.GetData()
      if (this.tblformAutomationId == 1) {
        this.FormName = 'مرخــصی'
        this.ApiAction = 'LeaveRequests'
        this.Column = [
          {
            name: 'nameUserReq',
            label: ' درخواست کننده',
            visibility: true,
          },
          {
            name: 'tblcombogrp103NoeMorakhasi',
            label: 'نوع مرخصی',
            visibility: true,
          },
          {
            name: 'tblCombogrp102NoeDarkhast',
            label: 'نوع درخواست',
            visibility: true,
          },
          {
            name: 'tarixAz',
            label: 'از تاریخ ',
            visibility: true,
          },
          {
            name: 'tarixTa',
            label: 'تا تاریخ ',
            visibility: true,
          },
          {
            name: 'startTime',
            label: 'از ساعت ',
            visibility: true,
          },
          {
            name: 'endTime',
            label: 'تا ساعت ',
            visibility: true,
          },
          {
            name: 'calcDateTime',
            label: 'میزان مرخصی',
            visibility: false,
          },
          {
            name: 'filePath',
            label: 'پیوست',
            visibility: true,
          },
          {
            name: 'Description',
            label: 'توضیحات مسئول',
            visibility: true,
          },
          {
            name: 'tblcombogrpId101VaziatName',
            label: 'وضعیت',
            visibility: true,
          },
        ]
      }
      if (this.tblformAutomationId == 2) {
        this.FormName = 'اضافــه کاری'
        this.ApiAction = 'OverTime'
        this.Column = [
          {
            name: 'nameUserReq',
            label: ' درخواست کننده',
            visibility: true,
          },
          {
            name: 'noe',
            label: 'نوع مرخصی',
            visibility: false,
          },
          {
            name: 'tblCombogrp102NoeDarkhast',
            label: 'نوع درخواست',
            visibility: false,
          },
          {
            name: 'date',
            label: 'از تاریخ ',
            visibility: true,
          },
          {
            name: 'date',
            label: 'تا تاریخ ',
            visibility: true,
          },
          {
            name: 'startTime',
            label: 'از ساعت ',
            visibility: true,
          },
          {
            name: 'endTime',
            label: 'تا ساعت ',
            visibility: true,
          },
          {
            name: 'dayCount',
            label: 'میزان مرخصی',
            visibility: false,
          },
          {
            name: 'des',
            label: 'توضیحات درخواست کننده',
            visibility: true,
          },
          {
            name: 'filePath',
            label: 'پیوست',
            visibility: true,
          },
          {
            name: 'Description',
            label: 'توضیحات مسئول',
            visibility: true,
          },
          {
            name: 'tblcombogrpId101VaziatName',
            label: 'وضعیت',
            visibility: true,
          },
        ]
      }
      if (this.tblformAutomationId == 3) {
        this.FormName = 'مـــاموریت'
        this.ApiAction = 'Misson'

        this.Column = [
          {
            name: 'nameUserReq',
            label: ' درخواست کننده',
            visibility: true,
          },
          {
            name: 'noe',
            label: 'نوع مرخصی',
            visibility: false,
          },
          {
            name: 'tblCombogrp102NoeDarkhast',
            label: 'نوع درخواست',
            visibility: false,
          },
          {
            name: 'date',
            label: 'از تاریخ ',
            visibility: true,
          },
          {
            name: 'date',
            label: 'تا تاریخ ',
            visibility: true,
          },
          {
            name: 'startTime',
            label: 'از ساعت ',
            visibility: true,
          },
          {
            name: 'endTime',
            label: 'تا ساعت ',
            visibility: true,
          },
          {
            name: 'dayCount',
            label: 'میزان مرخصی',
            visibility: false,
          },
          {
            name: 'des',
            label: 'توضیحات درخواست کننده',
            visibility: true,
          },
          {
            name: 'filePath',
            label: 'پیوست',
            visibility: true,
          },
          {
            name: 'Description',
            label: 'توضیحات مسئول',
            visibility: true,
          },
          {
            name: 'tblcombogrpId101VaziatName',
            label: 'وضعیت',
            visibility: true,
          },
        ]
      }
      if (this.tblformAutomationId == 4) {
        this.FormName = 'خریـــد'
        this.ApiAction = 'BuyRequest'

        this.Column = [
          {
            name: 'nameUserReq',
            label: ' درخواست کننده',
            visibility: true,
          },
          {
            name: 'dateTimeInsert',
            label: 'تاریخ درخواست',
            visibility: true,
          },
          {
            name: 'commodity',
            label: 'کالا',
            visibility: true,
          },
          {
            name: 'count',
            label: 'تعداد',
            visibility: true,
          },
          {
            name: 'for',
            label: 'توضیحات درخواست کننده',
            visibility: true,
          },
          {
            name: 'filePath',
            label: 'پیوست',
            visibility: true,
          },
          {
            name: 'Description',
            label: 'توضیحات مسئول',
            visibility: true,
          },
          {
            name: 'tblcombogrpId101VaziatName',
            label: 'وضعیت',
            visibility: true,
          },
        ]
      }
      if (this.tblformAutomationId == 5) {
        this.FormName = 'پرداخـــت هزینه'
        this.ApiAction = 'CostPermission'
        this.Column = [
          {
            name: 'nameUserReq',
            label: ' درخواست کننده',
            visibility: true,
          },
          {
            name: 'dateTimeInsert',
            label: 'تاریخ درخواست',
            visibility: true,
          },
          {
            name: 'amount',
            label: 'مبلغ',
            visibility: true,
          },
          {
            name: 'for',
            label: 'توضیحات درخواست کننده',
            visibility: true,
          },
          {
            name: 'filePath',
            label: 'پیوست',
            visibility: true,
          },
          {
            name: 'Description',
            label: 'توضیحات مسئول',
            visibility: true,
          },
          {
            name: 'tblcombogrpId101VaziatName',
            label: 'وضعیت',
            visibility: true,
          },
        ]
      }
      if (this.tblformAutomationId == 6) {
        this.FormName = 'مجوز پرداخـــت هزینه (مساعده)'
        this.ApiAction = 'PaymentPermission'
        this.Column = [
          {
            name: 'nameUserReq',
            label: 'درخواست کننده',
            visibility: true,
          },
          {
            name: 'amount',
            label: 'مبلغ ',
            visibility: true,
          },
          {
            name: 'description',
            label: 'توضیحات ',
            visibility: true,
          },
          {
            name: 'filePath',
            label: 'پیوست',
            visibility: true,
          },
          {
            name: 'Description',
            label: 'توضیحات مسئول',
            visibility: true,
          },
          {
            name: 'tblcombogrpId101VaziatName',
            label: 'وضعیت',
            visibility: true,
          },
        ]
      }
    } else {
      this.$router.go(-1)
    }
  },
  components: { Card, BnpGrid, SearchableCombo, RequestInfo, Modal },
}
</script>
<style scoped>
.box {
  /* border: 2px solid #b48810 !important; */
  background: var(--sidebar-bg-color);
  border-radius: 5px !important;
  text-align: center;
}
.box:hover {
  color: #5cb0ff;
}
</style>
